import { defineComponent, h } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

export default defineComponent({
  name: 'App',
  components: {
    Bar
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
            padding: 25,
            labels: {
              font: {

              }
            }
          },
          tooltip: {
            callbacks: {
              title: () => "",
              label: function(context) {
                let label = context.dataset.label || '';
                let label2 = '';
                let index = context.dataIndex;

                if (label) {
                  label += ': ';
                }

                if (context.parsed.y !== null) {
                  label += context.dataset.tooltips[index];
                  const barStart = context.parsed._custom ? context.parsed._custom.barStart : null;
                  const barEnd = context.parsed._custom ? context.parsed._custom.barEnd : null;

                  if (barStart === 0) {
                    label2 += context.parsed.y + " T";
                  } else if (context.dataset.backgroundColor[index] === "#da5455") {
                    let diff = Number(barStart) - Number(barEnd);
                    diff = -(diff.toFixed(2));
                    label2 += "+" + diff + " T";
                  } else {
                    let diff = Number(barStart) - Number(barEnd);
                    diff = -(diff.toFixed(2));
                    label2 += "-" + diff + " T";
                  }
                }

                if (context.dataset.tooltips[index] === "") {
                  return [label2 + "onnes"];
                } else {
                  return [label2, label];
                }
              }
            }
          },
          datalabels: {
            display: false // Disable data labels on bars
          }
        },
        scales: {
          y: {
            position: 'left',
            grid: {
              display: true,
              color: "#e4e6e8",
            },
            ticks: {
              maxTicksLimit: 10,
              font: {
                size: 10
              },
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              maxTicksLimit: 10,
              font: {
                size: 10
              },
              maxRotation: 0,
              minRotation: 0,
            }
          }
        }
      }
    };
  },
  render() {
    return h('div', { style: { height: '400px' } }, [ // Set height directly
      h(Bar, {
        data: this.chartData,
        options: this.options
      })
    ]);
  }
});
